import React from "react";
import "../styles/GraphCard.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";

function Graph_card({ data = [] }) {

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "700px",
        height: "400px",
        background: "#dce4e6",
        padding: "5px",
        borderRadius: "8px",
        margin: "auto",
      }}
    >
      <h5 className="graph-title"
  style={{
    textAlign: "center",
    marginBottom: "15px",
    fontWeight: "600",
    color: "#333"
  }}
>
  Centre Wise Distribution
</h5>

      <ResponsiveContainer width="100%" height="85%">
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#b0bec5" />

          <XAxis dataKey="label" />

          <YAxis
            domain={[0, 400]}
            ticks={[0, 50, 100, 150, 200, 250, 300, 350, 400]}
            interval={0}
            tick={{ fontSize: 12 }}
            label={{
              value: "Samples Completed",
              angle: -90,
              position: "insideLeft",
              style: { textAnchor: "middle", fontSize: 14 }
            }}
          />

          <Tooltip />
          <Legend />

          <Bar
            dataKey="value"
            name="Study Centres ➜"
            radius={[4, 4, 0, 0]}
            barSize={40}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={`${entry.color}40`}
                stroke={entry.color}
                strokeWidth={2}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default Graph_card;
